import React from "react";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";
import { KButton, KDialog, KIcon, KTable } from "@kyburz/kdesign-system";
import BaseLayout from "../../components/layouts/BaseLayout";
import {
  useDeleteSMSCommand,
  useGetSMSCommands,
} from "../../apiCalls/config/sms";
import { useStyles } from "./styles";
import { setAlert } from "../../redux/actions/actions";
import useSetState from "../../hooks/useSetState";
import { smsColumns } from "./smsTableColumns";

const SMSCommands = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const { data: SMSCommandsData = [], request: getSMSCommands } =
    useGetSMSCommands();
  const { request: handleDelete } = useDeleteSMSCommand();

  const [{ showDeleteDialog, deleteSMSId }, setState] = useSetState({
    showDeleteDialog: false,
    deleteSMSId: null,
  });

  const columns = smsColumns(history, setState);

  const deleteDialog = (
    <KDialog
      size="xs"
      title="Delete SMS Command"
      open={showDeleteDialog}
      primaryCTAonClick={() => {
        handleDelete(deleteSMSId._id)
          .then(() =>
            dispatch(
              setAlert(
                `SMS Command ${deleteSMSId?.name} has been deleted`,
                "success",
              ),
            ),
          )
          .catch((response) =>
            dispatch(setAlert(`Delete failed! ${response?.details}`, "error")),
          )
          .then(() => setState({ showDeleteDialog: false }, getSMSCommands()));
      }}
      primaryCTAColor="danger"
      primaryCTAText="Delete"
      secondaryCTAonClick={() => setState({ showDeleteDialog: false })}
      secondaryCTAText="Cancel"
    >
      <p>Are you sure you want to delete {deleteSMSId?.name}?</p>
    </KDialog>
  );

  return (
    <BaseLayout title="SMS Commands">
      <div className={classes.ctaContainer}>
        <KButton
          icon={<KIcon icon="plus" />}
          onClick={() => history.push("/config/sms/create")}
        >
          New SMS Command
        </KButton>
      </div>
      <KTable data={SMSCommandsData} columns={columns} hasFilter />
      {deleteDialog}
    </BaseLayout>
  );
};

export default SMSCommands;
